import Vue from 'vue';

import Fragment from 'vue-fragment';
Vue.use(Fragment.Plugin);

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);

import TableComponent from 'vue-table-component';
Vue.use(TableComponent);

import vmodal from 'vue-js-modal'
Vue.use(vmodal);

import App from './App.vue';
import router from './router';
import store from './store'

import '@/assets/scss/style.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created() {
    const token = JSON.parse(localStorage.getItem('leadgem_token'));
    const id = JSON.parse(localStorage.getItem('leadgem_id'));
    const email = JSON.parse(localStorage.getItem('leadgem_email'));

    if (token && id && email) {
      this.$store.commit('SET_USER_DATA', { token: token, email: email, id: id });
    }
  },
  render: h => h(App)
}).$mount('#app');
